module.exports = __webpack_public_path__ + "img/4-April.8ea1087a.jpg";